export const ProdutoStatusEnum = {
  Disponivel: 'Disponivel',
  Reservada: 'Reservada',
  Indisponivel: 'Indisponivel',
  Vendida: 'Vendida',
} as const
export type TProdutoStatusEnum = keyof typeof ProdutoStatusEnum

export const ProdutoTipoLegendaStatusEnum = {
  Disponivel: 'Disponivel',
  ReservadoPeloVendedor: 'ReservadoPeloVendedor',
  ReservadoPorProposta: 'ReservadoPorProposta',
  Indisponivel: 'Indisponivel',
}
export type TProdutoTipoLegendaStatusEnum = keyof typeof ProdutoTipoLegendaStatusEnum

export type TProduto = {
  idExterno: number
  id: string
  descricao: string
  valor: number
  status: TProdutoStatusEnum
  altaProcura: boolean
  tipoLegendaStatus: TProdutoTipoLegendaStatusEnum
  detalhamentoStatus?: string
}

export const TipoProdutoEnum = {
  Unidade: 'Unidade',
  Acessorio: 'Acessorio',
  VagaPadrao: 'VagaPadrao',
  Lote: 'Lote',
} as const
export type TTipoProdutoEnum = keyof typeof TipoProdutoEnum
export type TTipoProdutoVerticalEnum = Exclude<TTipoProdutoEnum, 'Lote'>
export type TTipoProdutoValidoEnum = Exclude<TTipoProdutoEnum, 'VagaPadrao'>

export type TGetDetalhesProdutoBaseResponse = {
  id: string
  idExterno: number
  nome: string
  codigo: string
  status: TProdutoStatusEnum
  tipoLegendaStatus: TProdutoTipoLegendaStatusEnum
  detalhamentoStatus?: string
  metragem?: string
  blocoId: string
  unidadeDeNegocioId: string
}
